import type {AutocompleteController} from '../../../../ui-widgets/autocomplete/utils';


export function ariaAutocompleteButton(button: HTMLButtonElement, autocompleteController: AutocompleteController) {
    button.setAttribute('aria-controls', autocompleteController.resultListId);
    const subscription = autocompleteController.getState$().subscribe((state) => {
        button.setAttribute('aria-expanded', state.expanded.toString());
    })

    return {
        destroy: () => subscription.unsubscribe()
    }
}